import React, { createContext, useReducer} from 'react'

const initialState = {
    user: null,
    userRest: null,
    isCheckingAuth: true,
    empresas: null
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'reset':
            return initialState
        case 'setUser':
            return { ...state, user: action.payload, isCheckingAuth: false }  
        case 'setEmpresas':
            return { ...state, empresas: action.payload }  
        case 'isCheckingAuth':
            return { ...state, isCheckingAuth: action.payload }     
        case 'setUserRest':
            return { ...state, userRest: action.payload}
        default:
            return state
    }
}




const GlobalContext = createContext(initialState)
const GlobalContextProvider = props => <GlobalContext.Provider value={useReducer(reducer, initialState)}>{props.children}</GlobalContext.Provider>


export { GlobalContext, GlobalContextProvider}
